import { Box, Container, Typography } from "@mui/material";

function Requerimentos() {
  return (
    <Container sx={{ px: { xs: 2, sm: 3 } }}>
      <Box sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 4 } }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2.125rem" } }}
        >
          Requerimentos
        </Typography>
      </Box>
    </Container>
  );
}

export default Requerimentos;
